import { get } from '../../Common/utils';

import { dropDownDefault } from './constants';

const normalizeAggregators = (aggregators = []) =>
  dropDownDefault.concat(
    aggregators.map(aggregator => ({
      label: get(aggregator, 'aggregatorID', ''),
      value: get(aggregator, 'aggregatorID', ''),
    })),
  );

const normalizePayers = (payers = []) =>
  dropDownDefault.concat(
    payers.map(payer => {
      const id = get(payer, 'payerID', '');

      return {
        label: id ? `${get(payer, 'payerName', '')} (${id})` : '',
        value: id,
      };
    }),
  );

const normalizeReasons = (reasons = []) =>
  reasons.map(reason => ({
    reasonCode: get(reason, 'reasonCode', ''),
    description: get(reason, 'description', ''),
    noteRequired: get(reason, 'noteRequired', ''),
    alertType: get(reason, 'alertType', ''),
  }));

export { normalizeAggregators, normalizePayers, normalizeReasons };
